import { useTranslation } from 'react-i18next';
import { useSiteLang } from '../../layout/use-site-lang.js';
import { MockPhoneFrame } from '../mock-phone-frame.jsx';
import { TransactionsCard } from '../transactions-card.jsx';
import { getMockTransactions } from '../mock-data/mock-transactions.js';

/**
 * Mobile use-case mockup: a compact transactions feed in the phone frame,
 * with the quick-add Thyme logo button highlighted.
 * @returns {JSX.Element}
 */
export function MobileScreen() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const rows = getMockTransactions(lang).filter((txn) => !txn.isTransferPair);
	return (
		<div className="mock-row">
			<MockPhoneFrame highlightAdd>
				<TransactionsCard rows={rows} columnKeys={['date', 'type', 'amount']} />
			</MockPhoneFrame>
			<div className="use-case-callout card">
				<h3>{t('usecase.mobile.quickadd.title')}</h3>
				<p>{t('usecase.mobile.quickadd.body')}</p>
			</div>
		</div>
	);
}
